import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Dashboard from './Dashboard';
import {BudgetOverviewPageWrapper} from './BudgetOverviewPage.styled';
import CustomScrollDiv from '../../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';

const BudgetOverviewPage = ({project, company, viewer}) => {
	return (
		<>
			<CustomScrollDiv>
				<BudgetOverviewPageWrapper>
					<Dashboard project={project} company={company} viewer={viewer} />
				</BudgetOverviewPageWrapper>
			</CustomScrollDiv>
		</>
	);
};

export default createFragmentContainer(BudgetOverviewPage, {
	project: graphql`
		fragment BudgetOverviewPage_project on ProjectType {
			id
			name
			...Dashboard_project
		}
	`,
	company: graphql`
		fragment BudgetOverviewPage_company on Company {
			id
			name
			...Dashboard_company
		}
	`,
});
